import { SharedUtils } from "../utilities/shared-utils";

export class LegalEntityBasicInfo {
    id: number | undefined;
    statusId: number | undefined;
    roles: EnumLegalEntityRole[] | undefined;
    rolesNew: EnumLegalEntityRole[] | undefined;
    profile: EnumLegalEntityProfile | undefined;
    companyName: string | undefined;
    brandName: string | undefined;
    fiscalCode: string | undefined;
    vatNumber: string | undefined;
    legalFormId: number | undefined;

    getProfileKeyString(): string {
        return SharedUtils.getEnumKey(EnumLegalEntityProfile, this.profile ?? '') as string;
    }

    getProfileValueString(): string {
        return SharedUtils.getEnumValue(EnumLegalEntityProfile, this.profile ?? '') as string;
    }

    public getRolesKeyString(): string {
        let legalEntityRoles: string = "";
        if ( SharedUtils.inputValueIsPresent(this.roles) && this.roles!.length > 0 ) {
            this.roles!.forEach( (role: EnumLegalEntityRole) => {
                if (legalEntityRoles === "") {
                    legalEntityRoles = role.toString() === "NONE" ? legalEntityRoles : legalEntityRoles.concat(role.toString());
                } else {
                    legalEntityRoles = role.toString() === "NONE" ? legalEntityRoles : legalEntityRoles.concat(", " + role.toString());
                }
            });
        }
        return legalEntityRoles;
    }

    public getRolesValueString(): string {
        let legalEntityRoles: string = "";
        if (SharedUtils.inputValueIsPresent(this.roles) && this.roles!.length > 0) {
            this.roles!.forEach( (role: EnumLegalEntityRole) => {
                if (legalEntityRoles === "") {
                    legalEntityRoles = (role.toString() === "NONE") ? legalEntityRoles : legalEntityRoles.concat( (SharedUtils.getEnumValue(EnumLegalEntityRole, role)?.toString() ?? "") );
                } else {
                    legalEntityRoles = role.toString() === "NONE" ? legalEntityRoles : legalEntityRoles.concat(", " + (SharedUtils.getEnumValue(EnumLegalEntityRole, role)?.toString() ?? "") );
                }
            });
        }
        return legalEntityRoles;
    }

    public getRolesNewKeyString(): string {
        let legalEntityRoles: string = "";
        if ( SharedUtils.inputValueIsPresent(this.rolesNew) && this.rolesNew!.length > 0 ) {
            this.rolesNew!.forEach( (role: EnumLegalEntityRole) => {
                if (legalEntityRoles === "") {
                    legalEntityRoles = role.toString() === "NONE" ? legalEntityRoles : legalEntityRoles.concat(role.toString());
                } else {
                    legalEntityRoles = role.toString() === "NONE" ? legalEntityRoles : legalEntityRoles.concat(", " + role.toString());
                }
            });
        }
        return legalEntityRoles;
    }

    public getRolesNewValueString(): string {
        let legalEntityRoles: string = "";
        if (SharedUtils.inputValueIsPresent(this.rolesNew) && this.rolesNew!.length > 0) {
            this.rolesNew!.forEach( (role: EnumLegalEntityRole) => {
                if (legalEntityRoles === "") {
                    legalEntityRoles = (role.toString() === "NONE") ? legalEntityRoles : legalEntityRoles.concat( (SharedUtils.getEnumValue(EnumLegalEntityRole, role)?.toString() ?? "") );
                } else {
                    legalEntityRoles = role.toString() === "NONE" ? legalEntityRoles : legalEntityRoles.concat(", " + (SharedUtils.getEnumValue(EnumLegalEntityRole, role)?.toString() ?? "") );
                }
            });
        }
        return legalEntityRoles;
    }

    getStatusValueString(): string {
        return EnumLegalEntityStatus[this.statusId ?? 0] as string;
    }

    getLegalFormValueString(): string {
        return EnumLegalFormCode[this.legalFormId ?? 0] as string;
    }

    public static parseLegalEntityBasicInfo(stringifiedLegalEntityBasicInfo: LegalEntityBasicInfo): LegalEntityBasicInfo | undefined {
        if(SharedUtils.inputValueIsEmpty(stringifiedLegalEntityBasicInfo) || SharedUtils.inputValueIsEmpty(stringifiedLegalEntityBasicInfo.id)) {
            return undefined;
        }
        let newLegalEntityBasicInfo: LegalEntityBasicInfo = new LegalEntityBasicInfo();

        if(stringifiedLegalEntityBasicInfo.id) newLegalEntityBasicInfo.id = stringifiedLegalEntityBasicInfo.id;
        if(stringifiedLegalEntityBasicInfo.statusId) newLegalEntityBasicInfo.statusId = stringifiedLegalEntityBasicInfo.statusId;

        if (SharedUtils.inputValueIsPresent(stringifiedLegalEntityBasicInfo.roles)) {
            // console.log("LegalEntityBasicInfo.parseLegalEntityBasicInfo() - stringifiedLegalEntityBasicInfo.roles: " + stringifiedLegalEntityBasicInfo.roles);
            newLegalEntityBasicInfo.roles = new Array<EnumLegalEntityRole>();
            let counter: number = stringifiedLegalEntityBasicInfo.roles?.length ?? 0;
            for (let i : number = 0; i < counter; i++) {
                newLegalEntityBasicInfo.roles.push(stringifiedLegalEntityBasicInfo.roles![i]);
            }
            // console.log("LegalEntityBasicInfo.parseLegalEntityBasicInfo() - newLegalEntityBasicInfo.roles: " + newLegalEntityBasicInfo.roles);
        } else {
            throw new Error("LegalEntityInfo.parseLegalEntityInfo() - ERROR - LegalEntityRoles not found.  UserLegalEntityInfo.userLegalEntityRoles: " + stringifiedLegalEntityBasicInfo.roles);
        }

        if (SharedUtils.inputValueIsPresent(stringifiedLegalEntityBasicInfo.rolesNew)) {
            newLegalEntityBasicInfo.rolesNew = new Array<EnumLegalEntityRole>();
            let counter: number = stringifiedLegalEntityBasicInfo.rolesNew?.length ?? 0;
            for (let i : number = 0; i < counter; i++) {
                newLegalEntityBasicInfo.rolesNew.push(stringifiedLegalEntityBasicInfo.rolesNew![i]);
            }
        }
        if(stringifiedLegalEntityBasicInfo.profile) newLegalEntityBasicInfo.profile = stringifiedLegalEntityBasicInfo.profile;
        if(stringifiedLegalEntityBasicInfo.companyName) newLegalEntityBasicInfo.companyName = stringifiedLegalEntityBasicInfo.companyName;
        if(stringifiedLegalEntityBasicInfo.brandName) newLegalEntityBasicInfo.brandName = stringifiedLegalEntityBasicInfo.brandName;
        if(stringifiedLegalEntityBasicInfo.legalFormId) newLegalEntityBasicInfo.legalFormId = stringifiedLegalEntityBasicInfo.legalFormId;
        if(stringifiedLegalEntityBasicInfo.fiscalCode) newLegalEntityBasicInfo.fiscalCode = stringifiedLegalEntityBasicInfo.fiscalCode;
        if(stringifiedLegalEntityBasicInfo.vatNumber) newLegalEntityBasicInfo.vatNumber = stringifiedLegalEntityBasicInfo.vatNumber;

        return newLegalEntityBasicInfo;
    }
}

export enum EnumLegalEntityRole {
    NONE = 'none',
    ANY = 'any',
    SURVEYOR_CUSTOMER = 'presentazione istanze',
    SURVEYOR_SUPPLIER = 'fornitore del servizio',
    SYSTEM_ADMINISTRATOR = 'amministratore del sistema',
    CUSTOMER_CARE = 'customer care'
}

export enum EnumLegalEntityProfile {
    BUILDING_MANAGER = 'amministratore di condominio',
    ENGINEERING_FIRM = 'impresa di costruzioni',
	REAL_ESTATE_AGENCY = 'agenzia immobiliare',
    SURVEYOR = 'studio tecnico geometra',
}

export enum EnumLegalEntityStatus {
    approval = 10,
    active = 11,
    refused = 12,
    inactive = 13,
    suspended = 14,
    banned = 15,
    erased = 16,
    closed = 17
}

export enum EnumLegalFormCode {
    "S.p.A." = 1,
    "S.a.p.A." = 2,
    "S.r.l." = 3,
    "S.r.l.s." = 4,
    "S.a.s." = 5,
    "S.n.c." = 6,
    "S.C." = 7,
    "D.I." = 8,
    "L.P." = 9,
    "S.s." = 10
}